import { z } from 'zod';

export const InputSchema = z.object({
    Countries: z.string(),
    Text: z.string(),
});

export const SuccessResponseSchema = z.array(
    z.object({
        Description: z.string(),
        Highlight: z.string(),
        Id: z.string(),
        Text: z.string(),
        Next: z.string(),
        Cursor: z.string(),
    })
);

export type SuccessResponse = z.infer<typeof SuccessResponseSchema>;
export type AddressItem = SuccessResponse extends Array<infer Inner> ? Inner : never

export const ErrorResponseSchema = z.array(
    z.object({
        Error: z.string(),
        Description: z.string(),
        Cause: z.string(),
        Resolution: z.string()
    })
);

type ErrorResponse = z.infer<typeof ErrorResponseSchema>;

export type TResponseType =
    { responseStatus: 'success'; data: SuccessResponse } |
    { responseStatus: 'error'; data: ErrorResponse }
